import { useEffect, useState } from 'react';

/**
 * 열고 닫을 때 바로 붙였다 떼지 않고 잠깐 머무르게 한다 — 메뉴가 툭 나타나고 툭 사라지면 급작스럽다.
 *
 *   mounted  DOM 에 있는가 (닫히는 동안에도 ms 만큼 남아 있다)
 *   shown    보이는 상태인가 — 붙은 다음 틀에 true 가 되어 CSS transition 이 '안 보임 → 보임' 으로 돈다
 */
export function usePresence(open: boolean, ms = 180): { mounted: boolean; shown: boolean } {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(open);
  useEffect(() => {
    if (open) {
      setMounted(true);
      // 한 틀 뒤에 보이게 — 같은 틀에 붙이고 바로 바꾸면 transition 이 일어나지 않는다
      const r = requestAnimationFrame(() => requestAnimationFrame(() => setShown(true)));
      return () => cancelAnimationFrame(r);
    }
    setShown(false);
    const t = window.setTimeout(() => setMounted(false), ms);
    return () => window.clearTimeout(t);
  }, [open, ms]);
  return { mounted, shown };
}
